export type SpacingUnit = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 8 | 10 | 12 | 16;

export type Spacings<T extends SpacingUnit = SpacingUnit> = Record<T, string>;

export const createSpacing = <SU extends SpacingUnit, ST extends Partial<Spacings<SU>>>(theme: {
  spacings: ST;
}): SpacingFn<ST> =>
  ((...args: Array<SpacingArg<ST>>) =>
    args
      .map((arg) => (typeof arg === 'number' ? theme.spacings[arg] ?? arg : arg))
      .join(' ')) as SpacingFn<ST>;

type SpacingArg<ST extends Partial<Spacings>> = keyof ST | string;

export type SpacingFn<ST extends Partial<Spacings>> = {
  (value: SpacingArg<ST>): string;
  (topBottom: SpacingArg<ST>, rightLeft: SpacingArg<ST>): string;
  (top: SpacingArg<ST>, rightLeft: SpacingArg<ST>, bottom: SpacingArg<ST>): string;
  (
    top: SpacingArg<ST>,
    right: SpacingArg<ST>,
    bottom: SpacingArg<ST>,
    left: SpacingArg<ST>,
  ): string;
};
